import * as React from 'react';

import styles from './ExtraVillages.css';
import { EExtraVillages, EXTRA_VILLAGES_TITLE_MAP } from '../../../constants/village';
import { VILLAGE_CARD_ROUTE } from '../../../routes';
import { TUser, MODERATION_STATUS_TYPES, IGetVillageResponseSchema } from '../../../types';
import { trackSimilarVillageClick, trackSimilarVillagesShow } from '../../ExtraVillages/tracking';

export interface IMobileExtraVillagesStoreProps {
  abGroup: number;
  user: TUser | undefined;
  villageData: IGetVillageResponseSchema;
}

export interface IMobileExtraVillagesOwnProps {
  type: EExtraVillages;
}

export type TExtraVillagesProps = IMobileExtraVillagesStoreProps & IMobileExtraVillagesOwnProps;

export class MobileExtraVillages extends React.Component<TExtraVillagesProps> {
  public componentDidMount() {
    const villages = this.getVillages();
    if (villages) {
      const { abGroup, type, villageData, user } = this.props;
      trackSimilarVillagesShow(villageData, user, abGroup, villages, type);
    }
  }

  public render() {
    const villages = this.getVillages();
    const {
      type,
      villageData: { village },
    } = this.props;
    if (!villages?.length || !village.builder || (this.isSimilar() && !this.shouldBuilderRender())) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>{EXTRA_VILLAGES_TITLE_MAP[type]}</div>
        <div>
          {villages.map(({ id, name, seo }, index) => (
            <a
              key={id}
              className={styles['link']}
              href={seo ? seo.url : `${VILLAGE_CARD_ROUTE}${id}`}
              onClick={this.onVillageLinkClick(id, index)}
            >
              КП «{name}»
            </a>
          ))}
        </div>
      </div>
    );
  }

  private isSimilar = () => this.props.type === EExtraVillages.Similar;

  private getVillages() {
    const {
      villageData: { nearbyVillages, similarVillages },
    } = this.props;

    return this.isSimilar() ? similarVillages : nearbyVillages;
  }

  private get builder() {
    return this.props.villageData.village.builder;
  }

  public shouldBuilderRender = () => this.builder?.moderationStatus === MODERATION_STATUS_TYPES.Published;

  private onVillageLinkClick = (villageId: number, index: number) => {
    return () => {
      const { abGroup, type, villageData, user } = this.props;
      trackSimilarVillageClick(villageData, user, abGroup, villageId, index + 1, type);
    };
  };
}
